export default "__VITE_ASSET__ZBDuo_uS__"